<template>
  <div class="product-review-head">
    <div
      v-if="answer"
      class="product-review-head__avatar answer"
    >
      <f-sprite-icon :icon-link="$options.icons.avatarAnswer.id" />
    </div>
    <div
      v-else
      class="product-review-head__avatar"
    >
      <f-sprite-icon :icon-link="$options.icons.avatarBg.id" />
    </div>

    <div class="product-review-head__info-wrap">
      <div>
        <span class="product-review-head__name">
          {{ userName }}
        </span>
        <span class="product-review-head__info">
          {{ date }}
        </span>
      </div>

      <template
        v-if="!answer"
      >
        <div class="product-review-head__info product-review-head__info-offset">
          {{ city }}
        </div>
        <div class="product-review-head__info product-review-head__info-offset2">
          Срок использования: {{ useTime }}
        </div>
        <div class="product-review-head__rating-wrap">
          <stars-rating
            class="product-review-head__stars-rating"
            size="12"
            :value="rating"
          />
          <div
            v-if="recommended"
            class="product-review-head__recommends"
          >
            Рекомендую!
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import avatarBg from '@images/avatar-bg.svg';
import avatarAnswer from '@images/avatar-answer.multi.svg';
import StarsRating from './review-stats/stars-rating.vue';

export default {
  name: "product-review-head",

  components: { StarsRating },

  icons: {
    avatarBg,
    avatarAnswer,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    city: {
      type: String,
      default: '',
    },
    rating: {
      type: Number,
      default: 0,
    },
    useTime: {
      type: String,
      default: '',
    },
    answer: {
      type: Boolean,
      default: false,
    },
    recommended: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    userName() {
      return this.answer? 'Магазин Funday' : this.name;
    }
  }
}
</script>

<style lang="scss">
  .product-review-head {
    display: flex;

    &__avatar {
      width: 40px;
      height: 40px;
      background-color: $blue_8;
      color: $blue;
      border-radius: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;

      @include breakpoint("desktop") {
        width: 48px;
        height: 48px;
        margin-right: 12px;
      }

      svg {
        width: 20px;
        height: 20px;
      }

      &.answer {
        svg {
          width: 40px;
          height: 40px;
        }
      }
    }

    &__name {
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      display: inline-block;
      margin-right: 6px;

      @include breakpoint("tablet") {
        font-size: 16px;
      }
    }

    &__info {
      font-size: 12px;
      line-height: 16px;
      color: $gray;

      @include breakpoint("desktop") {
        font-size: 14px;
      }
    }

    &__info-offset {
      margin-bottom: 4px;
    }

    &__info-offset2 {
      margin-bottom: 8px;
    }

    &__rating-wrap {
      display: flex;
      align-items: center;
      margin-top: 5px;
    }

    &__recommends {
      font-size: 12px;
      color: $rose;
      font-weight: bold;
    }

    &__stars-rating {
      margin-right: 8px;
    }
  }
</style>